import { FC, Fragment, useEffect } from "react"
import { IOTPCountDown } from "@/components/OTPCountDown/types";
import { CountBox, TextBox, Time, Title } from "@/components/OTPCountDown/styled";
import useWindowSize from "@/hooks/useWindowSize";


const OTPCountDown: FC<IOTPCountDown> = ({ time, timeLeft, setTimeLeft, onClick }) => {
    const size: { width: number | undefined, height: number | undefined } = useWindowSize();
    useEffect(() => {
        if (timeLeft === 0) {
            setTimeLeft(0)
        }
        if (!timeLeft) return;
        const intervalId = setInterval(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000)

        return () => clearInterval(intervalId);

    }, [timeLeft])

    const reSend = () => {
        if (onClick) {
            onClick();
        }
        setTimeLeft(time);
    }

    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft - minutes * 60;

    return (
        <CountBox timeLeft={timeLeft}>
            {size && size.width && size.width <= 768 ? (
                <Fragment>
                    <TextBox>
                        {timeLeft ? (
                            <Fragment>
                                <div>
                                    <Title>Kalan süre</Title>
                                </div>
                            </Fragment>
                        ) : (
                            <p style={{ color: "red" }} onClick={() => reSend()}>Yeni şifre gönder</p>
                        )}
                    </TextBox>
                    {timeLeft !== 0 && (
                        <Time>{minutes} dk, {seconds} sn</Time>
                    )}
                </Fragment>
            ) : (
                <Fragment>
                    {timeLeft ? (
                        <> <p>Kalan süre:</p><Time>{minutes} dk, {seconds} sn</Time></>
                    ) : (
                        <p style={{ color: "red", marginTop: "0px" }} onClick={() => reSend()}>Yeni şifre gönder</p>

                    )}
                </Fragment>
            )
            }
        </CountBox >
    )
}

export default OTPCountDown;
